export enum FormControlVisibleValueListBlock {
  Root = 'FormControlVisibleValueList',
}
